"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskViewTableQueryParamsSync = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const task_view_table_query_params_hydrators_map_1 = require("./task-view-table-query-params-hydrators.map");
const task_view_table_query_params_constants_1 = require("./task-view-table-query-params.constants");
const task_view_table_query_params_mappers_1 = require("./task-view-table-query-params.mappers");
const view_query_params_1 = require("../../../../common/view-query-params");
const task_view_1 = require("../../../../store/catalogs/task-view");
const store_1 = require("../../../../../store");
const useTaskViewTableQueryParamsSync = ({ dynamicColumns, onHydrateDynamicColumns, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const filter = (0, task_view_1.useTaskViewProductsTableFilter)();
    const search = (0, task_view_1.useTaskViewProductsTableSearch)();
    const sort = (0, task_view_1.useTaskViewProductsTableSort)();
    const pageSize = (0, task_view_1.useTaskViewProductsTablePageSize)();
    const defaultDynamicColumnsRef = (0, react_1.useRef)(dynamicColumns);
    const defaults = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, task_view_table_query_params_constants_1.taskViewTableQueryStateDefaults), { [view_query_params_1.ViewQueryStateField.DynamicColumns]: defaultDynamicColumnsRef.current })), []);
    const viewState = (0, react_1.useMemo)(() => (0, task_view_table_query_params_mappers_1.getTaskViewTableQueryState)({
        dynamicColumns,
        filter,
        pageSize,
        search,
        sort,
    }), [dynamicColumns, filter, pageSize, search, sort]);
    const handleHydrate = (0, react_1.useCallback)((state) => {
        if (!catalogId)
            return;
        (0, task_view_table_query_params_hydrators_map_1.hydrateTaskViewTableQueryState)({
            catalogId,
            dispatch,
            onHydrateDynamicColumns,
            state,
        });
    }, [catalogId, dispatch, onHydrateDynamicColumns]);
    return (0, view_query_params_1.useViewQueryParamsSync)({
        defaults,
        enabled: Boolean(catalogId),
        onHydrate: handleHydrate,
        viewState,
    });
};
exports.useTaskViewTableQueryParamsSync = useTaskViewTableQueryParamsSync;
